import { useQuery } from "@tanstack/react-query";
import { getDoctors } from "../api/get-doctors";

export const useGetDoctors = (enabled = true) => {
  return useQuery({
    queryKey: ["doctors"],
    queryFn: getDoctors,
    enabled,
  });
};
